import React, { useState, useEffect } from "react";

function AppliedFilter(props) {
  const { styles, filters, removeFilter, clearAllFilter } = props;

  return (
    <>
      {!!filters.length && (
        <div
          className={`${styles.upBlock} d-md-flex justify-content-between align-items-center`}
        >
          {filters.length === 1 ? (
            <a className={styles.badgeTp}>
              <bdo dir="ltr">{filters[0].label}</bdo>
              <i
                className="fas fa-times"
                onClick={() => removeFilter(filters[0])}
              ></i>
            </a>
          ) : (
            <Filters
              filters={filters}
              styles={styles}
              removeFilter={removeFilter}
              clearAllFilter={clearAllFilter}
            />
          )}
        </div>
      )}
    </>
  );
}

const filterRef = React.createRef();
function Filters(props) {
  const { filters, styles } = props;
  const [show, setShow] = useState(false);
  useEffect(() => {
    const outSideModalClickEvent = () => {
      if (filterRef && !filterRef.current?.contains(event.target)) {
        //setShow(false);
      }
    };
    const removeListener = () => {
      document.removeEventListener("mousedown", outSideModalClickEvent);
    };
    document.addEventListener("mousedown", outSideModalClickEvent);

    return () => removeListener;
  }, []);
  return (
    <div className={`${styles.upBlock} d-md-flex align-items-center`}>
      <div className={`${styles.sortBtnGroup} btn-group ${show ? "show" : ""}`}>
        <button
          className={`${styles.filterBtn}`}
          name="recordinput"
          data-toggle="dropdown"
          onClick={() => setShow(!show)}
        >
          {`${filters.length} Filter`}
        </button>
        <div
          ref={filterRef}
          className={`dropdown-menu ${styles.sortDropdown} ${
            styles.filterDropdown
          } ${show ? "show" : ""}`}
          aria-labelledby="dropdownMenuButton1"
        >
          {filters.map((k) => (
            <span key={k._id}>
              <bdo dir="ltr">{k.label}</bdo>
              <i
                className="fas fa-times"
                onClick={() => props.removeFilter(k)}
              ></i>
            </span>
          ))}
        </div>
      </div>
      <a className={styles.clearAll} onClick={props.clearAllFilter}>
        Clear All
      </a>
    </div>
  );
}

export default AppliedFilter;
